import { getNestedProperty } from '@opallabs/lambda'

const loadBudget = ({ state, id, context }) => {
  const budgetEntity = getNestedProperty(state, 'jsonApiEntities', 'budget')
  if (budgetEntity && id) {
    let budget
    const budgetIds = Object.keys(budgetEntity)
    budgetIds.forEach((key) => {
      const budgetContextId = getNestedProperty(
        budgetEntity,
        key,
        'relationships',
        context,
        'id'
      )
      if (budgetContextId === id.toString()) {
        budget = budgetEntity[key]
      }
    })
    return budget || {}
  }

  return {}
}

export default loadBudget
